export const isCarsSection = (sectionName?: string) => sectionName === 'cars';
export const isOver20k = (priceEuro?: number | null) =>
  (priceEuro ?? 0) > 20000;
export const isElectric = (fuelType?: string | null) => fuelType === 'Electric';
